import * as PIXI from 'pixi.js';
import gsap from "gsap";
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import Tools from '../utils/Tools';
import config from 'config';

export default class Skin extends PIXI.Container {
    constructor(skinName, skinIndex, skinContainer) {
        super();

        this.skinName = skinName;
        this.skinIndex = skinIndex;
        this.skinContainer = skinContainer;

        // Background of the icon
        this.skinBackground = null;
        // Icon of the skin
        this.skinIcon = null;
        // Mask of the skin, contains transparent circle and a lock icon
        this.maskContainer = null;
        // Selection ring of the skin
        this.selectionRing = null;

        ////////// Parameters
        // Distance between the skins
        this.distanceBetweenSkins = 80;
        // True if the skin selection is enabled
        this.isSkinSelectionEnabled = false;

        this.onClickSkin = this.onClickSkin.bind(this);

        this.initSkin();
    }

    initSkin() {
        //console.log('initSkin');
        // Check if the skin is already unlocked

        // Add itself into the skin container
        this.skinContainer.addChild(this);

        // Get the position of the skin according to the index, 3 * 3
        const rowNum = Math.floor(this.skinIndex / 3);
        const colNum = this.skinIndex - 3 * rowNum;
        const positionX = (colNum - 1) * this.distanceBetweenSkins;
        const positionY = (rowNum - 1) * this.distanceBetweenSkins - 280;

        this.x = positionX;
        this.y = positionY;

        // Load the hole background
        const holeTexture = AssetsManager.texturesPixi.holeBackground;
        this.skinBackground = new PIXI.Sprite(holeTexture);
        this.skinBackground.scale.set(0.2);
        this.skinBackground.anchor.set(0.5);
        this.addChild(this.skinBackground);

        // Load the icon images
        const skinIconName = this.skinName + "Icon";
        const skinIconTexture = AssetsManager.texturesPixi[skinIconName];
        this.skinIcon = new PIXI.Sprite(skinIconTexture);
        this.skinIcon.scale.set(0.18);
        this.skinIcon.anchor.set(0.5);
        this.addChild(this.skinIcon);

        // Load the mask of the skin
        this.maskContainer = new PIXI.Container();
        this.addChild(this.maskContainer);

        const circle = new PIXI.Graphics();
        circle.beginFill(0x000000);
        circle.drawCircle(0, 0, 24);
        circle.alpha = 0.5;
        circle.endFill();
        this.maskContainer.addChild(circle);

        const lockTexture = AssetsManager.texturesPixi.skinLock;
        var lockIcon = new PIXI.Sprite(lockTexture);
        lockIcon.scale.set(0.09);
        lockIcon.anchor.set(0.5);
        this.maskContainer.addChild(lockIcon);

        // Load the ring of selection
        this.selectionRing = new PIXI.Graphics();
        this.selectionRing.lineStyle(6, 0x40e4fe, 1);
        this.selectionRing.drawCircle(0, 0, 25);
        this.selectionRing.endFill();
        this.selectionRing.visible = false;
        this.addChild(this.selectionRing);
    }

    enableSelection() {
        if (!this.isSkinSelectionEnabled) {
            // Play the enable selection animation
            gsap.to(this.scale, { x: 1.5, y: 1.5, duration: 0.5 });
            this.selectionRing.visible = true;
            gsap.delayedCall(0.5, () => {
                gsap.to(this.scale, { x: 1, y: 1, duration: 0.5 });
                //Don't unselect the purchased skin on first start game
                this.skinName != config.currentSkin && (this.selectionRing.visible = false);
            });

            this.maskContainer.visible = false;

            this.skinIcon.interactive = true;
            this.skinIcon.buttonMode = true;
            this.skinIcon.on("pointerdown", this.onClickSkin);

            this.isSkinSelectionEnabled = true;
        }
    }

    onClickSkin() {

        if (!config.changeSkinReady) {
            return;
        }

        console.log("this.selectionRing.visible", this.selectionRing.visible);
        if (this.selectionRing.visible == true) {
            GameManager.CURRENT_SKIN = "";
        }
        else {
            GameManager.changeSkinByBtn(this.skinName, this);
            // GameManager.CURRENT_SKIN = this.skinName;
        }

        // Save the current skin on the SDK
        GameManager.uploadPlayerData();
    }

    blinkSelection() {
        this.selectionRing.visible = true;
        gsap.delayedCall(0.2, () => {
            this.selectionRing.visible = false;
        });
    }

    selectSkin() {
        this.selectionRing.visible = true;
    }

    deselectSkin() {
        this.selectionRing.visible = false;
    }


    loadingSkin() {
        console.log("loadingSkin");
        config.changeSkinReady = false;
        this.scaleTween && this.scaleTween.kill();
        this.scaleTween = gsap.to(this.selectionRing.scale, { duration: .1, x: .82, y: .82, yoyo: true, repeat: -1, yoyoEase: "none" });
    }

    skinLoaded() {
        console.log("skinLoaded");
        config.changeSkinReady = true;
        this.scaleTween && this.scaleTween.kill();
        this.scaleTween = gsap.to(this.selectionRing.scale, { duration: .1, x: 1, y: 1 });
    }

}